import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LoadingStatus } from 'types/common_types';

import actions from './cart_product_creator.actions';

import { realNumber } from 'utils/math_util';

type CartProductCreatorSliceInitialState = {
  status: LoadingStatus;
  addToCartSuccess: boolean;
  addToCartWasEdit: boolean;
  addToCartQuantity: number;
};

const initialState: CartProductCreatorSliceInitialState = {
  status: 'idle',
  addToCartSuccess: false,
  addToCartWasEdit: false,
  addToCartQuantity: 1,
};

const slice = createSlice({
  name: 'cartProductCreator',
  initialState,
  reducers: {
    resetAddToCartSuccess(state) {
      return { ...state, addToCartSuccess: false, addToCartWasEdit: false };
    },
    updateQuantity(state, { payload }: PayloadAction<string>) {
      let value = parseInt(payload);

      // Allow 0 if number is deleted, but the add to cart button will be disabled
      if (!realNumber(value)) {
        value = 0;
      }

      return { ...state, addToCartQuantity: value };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(actions.addToCart.pending, (state) => {
        return { ...state, status: 'loading' };
      })
      .addCase(actions.addToCart.fulfilled, (state) => {
        return { ...state, status: 'idle', addToCartSuccess: true };
      })
      .addCase(actions.addToCart.rejected, (state, { payload }) => {
        return {
          ...state,
          status: 'idle',
        };
      })
      .addCase(actions.saveCartProductEdit.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          addToCartWasEdit: true,
        };
      })
      .addCase(actions.saveCartProductEdit.fulfilled, (state) => {
        return {
          ...state,
          addToCartSuccess: true,
          status: 'idle',
        };
      })
      .addCase(actions.saveCartProductEdit.rejected, (state) => {
        return { ...state, addToCartSuccess: false, status: 'error' };
      });
  },
});

export default slice;
